const ALLOWED = new Set(["P", "BR", "STRONG", "B", "EM", "I", "U", "H2", "H3", "H4", "UL", "OL", "LI", "IMG", "SPAN", "DIV"]);
const VOID = new Set(["BR", "IMG"]);

export function looksLikeHtml(value) {
  return /<[a-z][\s\S]*>/i.test(String(value || ""));
}

export function stripHtml(value) {
  return String(value || "")
    .replace(/<(script|style)[^>]*>[\s\S]*?<\/\1>/gi, " ")
    .replace(/<[^>]+>/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

function okSrc(src) {
  const s = String(src || "").trim();
  if (!s || s.length > 2000) return "";
  const low = s.toLowerCase();
  if (low.startsWith("javascript:") || low.startsWith("vbscript:")) return "";
  if (low.startsWith("data:")) return low.startsWith("data:image/") ? s : "";
  if (s.startsWith("/") && !s.startsWith("//")) return s;
  try {
    const u = new URL(s);
    if (u.protocol === "http:" || u.protocol === "https:") return s;
  } catch { /* ignore */ }
  return "";
}

export function sanitizeProductHtml(html) {
  const raw = String(html || "");
  if (!looksLikeHtml(raw)) return raw;
  if (typeof document === "undefined") return stripHtml(raw);
  const wrap = document.createElement("div");
  wrap.innerHTML = raw;
  const walk = (node, parent) => {
    const kids = [...node.childNodes];
    for (const child of kids) {
      if (child.nodeType === 3) continue;
      if (child.nodeType !== 1) {
        child.remove();
        continue;
      }
      const tag = child.tagName;
      if (!ALLOWED.has(tag)) {
        const frag = document.createDocumentFragment();
        while (child.firstChild) frag.appendChild(child.firstChild);
        child.replaceWith(frag);
        continue;
      }
      [...child.attributes].forEach((attr) => {
        const name = attr.name.toLowerCase();
        if (tag === "IMG" && (name === "src" || name === "alt")) return;
        child.removeAttribute(attr.name);
      });
      if (tag === "IMG") {
        const src = okSrc(child.getAttribute("src"));
        if (!src) {
          child.remove();
          continue;
        }
        child.setAttribute("src", src);
        child.setAttribute("alt", child.getAttribute("alt") || "");
      }
      if (!VOID.has(tag)) walk(child, parent);
    }
  };
  walk(wrap, wrap);
  return wrap.innerHTML.trim();
}

export function toEditorHtml(value) {
  const raw = String(value || "");
  if (!raw) return "";
  if (looksLikeHtml(raw)) return sanitizeProductHtml(raw);
  return raw
    .split(/\n{2,}/)
    .map((p) => `<p>${p.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/\n/g, "<br>")}</p>`)
    .join("");
}
